import { RegionShared } from "@1games-ru/region-shared";
import { useEffect, useState } from "react";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";

export default function usePlayers(data: typeof RegionShared.Client.Requests.GetPlayersRequest) {
  const [isPending, setIsPending] = useState(false);
  const [players, setPlayers] = useState<
    null | typeof RegionShared.Client.Responses.GetPlayersResponse
  >(null);

  useEffect(() => {
    (async () => {
      setIsPending(true);
      const response:
        | RpcMpProviderFailedResponse
        | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.GetPlayersResponse> =
        await RpcMpProvider.getInstance().callClient(
          RegionShared.Client.Events.Player.GetPlayers,
          data,
        );
      if (response instanceof RpcMpProviderSuccessResponse) {
        setPlayers(response.data);
      }
      setIsPending(false);
    })();
  }, []);

  return { isPending, players };
}
